var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.article)?_c('content-body',{class:[
		'decodables',
		{
			wrapper: _vm.routeContext.params.assignmentId
		}
	],attrs:{"article":_vm.article,"article-list":_vm.articleList,"selected-article":_vm.selectedArticle,"route-context":_vm.routeContext,"on-article-select":_vm.onArticleSelect,"force-highlighting":_vm.whiteboardView,"decodables":true,"show-audio":false,"show-support":false,"show-challenge":false,"paragraphs-numbered":_vm.paragraphsNumbered}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }